export default "__VITE_ASSET__9a879e64__"